import React, { Fragment } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardBody from 'components/Card/CardBody.js';
import CardFooter from 'components/Card/CardFooter.js';
// react plugin for creating charts
import ChartistGraph from 'react-chartist';
import { multipleBarsChart } from 'variables/charts.js';

// @material-ui/icons
import Timeline from '@material-ui/icons/Timeline';

import styles from 'assets/jss/material-dashboard-pro-react/views/chartsStyle.js';

const useStyles = makeStyles(styles);

export default function Sale(props) {
  const { businessPartner } = props;

  const classes = useStyles();

  return (
    <Fragment>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Timeline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              Reporte de {businessPartner.CardType === 'C' ? 'ventas' : 'compras'}
            </h4>
          </CardHeader>
          <CardBody>
            <ChartistGraph
              data={multipleBarsChart.data}
              type="Bar"
              options={multipleBarsChart.options}
              listener={multipleBarsChart.animation}
            />
          </CardBody>
        </Card>
      </GridItem>
    </Fragment>
  );
}
